var path = 'log/activity/activity.tpl.html';
var html = "<react-component name='activity' />\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;